module.exports = __webpack_public_path__ + "static/img/pay-en.bf22c6f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer1/en/pay-en.png
// module id = UaZd
// module chunks = 0